import {
  Box,
  Typography,
  Switch,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toggleShowWinPercentage } from 'redux/slices';

export function WinPercentageToggle() {
  const { showWinPercentage } = useSelector((state) => state.game);
  const dispatch = useDispatch();

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography>Mostrar %</Typography>
      <Switch
        checked={showWinPercentage}
        onChange={() => dispatch(toggleShowWinPercentage())}
        size="small"
      />
    </Box>
  );
}
